export enum ToastType {
  ERROR = `error`,
  INFO = `info`,
  SUCCESS = `success`,
  DESTRUCTIVE = `destructive`,
  WARNING = `warning`,
}
